import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "./cn";
/**
 * Structural background — a faint engineered dot-grid + a ground glow.
 * Generated geometry, not a picture: says "infrastructure," not "marketing
 * dressing." Restrained by design. (CO 069)
 */
export function GridGlow({ className, glow = true, }) {
    return (_jsxs("div", { "aria-hidden": true, className: cn("pointer-events-none absolute inset-0 overflow-hidden", className), children: [_jsx("div", { className: "absolute inset-0 opacity-[0.5] dark:opacity-[0.35]", style: {
                    backgroundImage: "radial-gradient(circle, rgba(90,96,114,0.18) 1px, transparent 1px)",
                    backgroundSize: "26px 26px",
                    maskImage: "radial-gradient(ellipse 80% 60% at 50% 0%, black 30%, transparent 75%)",
                    WebkitMaskImage: "radial-gradient(ellipse 80% 60% at 50% 0%, black 30%, transparent 75%)",
                } }), glow && (_jsx("div", { className: "absolute inset-0 bg-[radial-gradient(900px_440px_at_50%_-8%,rgba(67,56,202,0.14),transparent_70%)] dark:bg-[radial-gradient(900px_440px_at_50%_-8%,rgba(99,102,241,0.20),transparent_70%)]" }))] }));
}
